module.exports = __webpack_public_path__ + "img/bot-error.3ecb1064.svg";